//Config
import { SOCKET_URL } from "./config";
import io from "socket.io-client";
//Instruments

export const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  forceNew: true,
});

export const Api = {
  sendEmailApi: ({ name, email, question, fileCustom }) => {
    const formData = new FormData();
    formData.append("name", name);

    formData.append("email", email);
    formData.append("message", question || "no message");

    formData.append(`file`, fileCustom);

    return fetch(`https://api.server.dev.fulcrum.rocks/api/contact/team`, {
      method: "POST",
      body: formData,
    });
  },
};
